export default function TileSkeleton() {
  return (
    <article
      aria-hidden="true"
      style={{
        background: 'var(--bg-surface)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'var(--border-subtle)',
        borderRadius: 'var(--radius-lg)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        animation: 'dp-skeleton-pulse 1400ms var(--ease-out) infinite alternate',
      }}
    >
      <style>{`
        @keyframes dp-skeleton-pulse {
          from { opacity: 0.55; }
          to   { opacity: 0.85; }
        }
      `}</style>
      {/* Header block */}
      <div
        style={{
          height: '120px',
          background: 'var(--dp-canvas-200)',
          flexShrink: 0,
        }}
      />
      {/* Body */}
      <div style={{ padding: 'var(--sp-4)', display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)' }}>
        <div style={{ height: '20px', width: '60%', background: 'var(--dp-canvas-200)', borderRadius: 'var(--radius-sm)' }} />
        <div style={{ height: '13px', width: '90%', background: 'var(--dp-canvas-200)', borderRadius: 'var(--radius-sm)' }} />
        <div style={{ height: '13px', width: '40%', background: 'var(--dp-canvas-200)', borderRadius: 'var(--radius-sm)' }} />
        <div style={{ height: '32px', marginTop: 'var(--sp-3)', background: 'var(--dp-canvas-200)', borderRadius: 'var(--radius-md)' }} />
      </div>
    </article>
  );
}
